import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'list-modal-ttt',
      templateUrl: './a-list-modal.component.html',
    })

export class AListModalComponent {
  @Input() list_text;

  constructor(
    public activeModal: NgbActiveModal
  ) {}
  
  reflectList() {
    this.activeModal.close(this.list_text);
  }
}




// WEBPACK FOOTER //
// ./src/app/a0103-question-register/a-list-modal.component.ts